var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import Checkbox from '../Checkbox';
var SelectionCheckboxAll = /** @class */ (function (_super) {
    __extends(SelectionCheckboxAll, _super);
    function SelectionCheckboxAll(props) {
        var _this = _super.call(this, props) || this;
        _this.setCheckState = function (props) {
            var checked = _this.getCheckState(props);
            var indeterminate = _this.getIndeterminateState(props);
            _this.setState(function (prevState) {
                var newState = {};
                if (indeterminate !== prevState.indeterminate) {
                    newState.indeterminate = indeterminate;
                }
                if (checked !== prevState.checked) {
                    newState.checked = checked;
                }
                return newState;
            });
        };
        _this.getCheckState = function (props) {
            var data = props.data;
            var checked = _this.checkSelection(props, data, 'every');
            return checked;
        };
        _this.handleSelectAllChange = function (e) {
            var checked = e.target.checked;
            _this.props.onSelect(checked ? 'all' : 'removeAll');
        };
        _this.state = {
            checked: _this.getCheckState(props),
            indeterminate: _this.getIndeterminateState(props),
        };
        return _this;
    }
    SelectionCheckboxAll.prototype.componentDidMount = function () {
        this.subscribe();
    };
    SelectionCheckboxAll.prototype.componentWillReceiveProps = function (nextProps) {
        this.setCheckState(nextProps);
    };
    SelectionCheckboxAll.prototype.componentWillUnmount = function () {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    SelectionCheckboxAll.prototype.subscribe = function () {
        var _this = this;
        var store = this.props.store;
        // 当 store 里的 selectedRowKeys 数据更新时，就会触发 subscribe 里的函数
        this.unsubscribe = store.subscribe(function () {
            _this.setCheckState(_this.props);
        });
    };
    SelectionCheckboxAll.prototype.checkSelection = function (props, data, type) {
        var _a = props || this.props, store = _a.store, getCheckboxPropsByItem = _a.getCheckboxPropsByItem, getRecordKey = _a.getRecordKey;
        // type should be 'every' | 'some'
        if (type === 'every' || type === 'some') {
            return data[type](function (item, i) { return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0; });
        }
        return false;
    };
    SelectionCheckboxAll.prototype.getIndeterminateState = function (props) {
        var data = props.data;
        var indeterminate = this.checkSelection(props, data, 'some') && !this.checkSelection(props, data, 'every');
        return indeterminate;
    };
    SelectionCheckboxAll.prototype.render = function () {
        var disabled = this.props.disabled;
        var _a = this.state, checked = _a.checked, indeterminate = _a.indeterminate;
        return (React.createElement(Checkbox, { disabled: disabled, checked: checked, indeterminate: indeterminate, onChange: this.handleSelectAllChange }));
    };
    return SelectionCheckboxAll;
}(Component));
export default SelectionCheckboxAll;
